module.exports = __webpack_public_path__ + "static/media/snow2.5c72bf9d.webm";